import Alert from "@mui/material/Alert";
import PagePaper from "../../../components/Paper/PagePaper";

export default function GestionDashboard() {
	return (
		<PagePaper name="Tableau de bord">
			<Alert
				severity="warning"
				color="info"
			>
				Fonctionnalité en cours de dévelopement
			</Alert>
		</PagePaper>
	);
}
